import React from 'react'
import { Progress, Tooltip } from 'antd'
import classnames from 'classnames'
import { injectIntl } from 'react-intl'
import { defineProgressColor } from 'services/utils'
import style from './style.module.scss'

const RichProgressBar = ({ goal, percent, intl: { formatMessage }, className, shortPercentCaption }) => {
  const progressBarWidth = 100 - percent
  const progressDescription = shortPercentCaption ? (
    <Tooltip title={formatMessage({ id: 'components.rich-progress-bar.percentage-of-completion' }, { percent })}>
      {percent}%
    </Tooltip>
  ) : (
    formatMessage({ id: 'components.rich-progress-bar.percentage-of-completion' }, { percent })
  )

  return (
    <div className={classnames(style.richProgressBar, className)}>
      <div className={style.goalInfo}>
        {goal}
        <div style={{ color: defineProgressColor(percent) }}>
          {progressDescription}
        </div>
      </div>
      <Progress
        percent={progressBarWidth}
        showInfo={false}
        strokeWidth={4}
        strokeColor="#E7E9EE"
      />
    </div>
  )
}

export default injectIntl(RichProgressBar)
